import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/violationActions'
import * as api from '../../api/job/violations'

function* violationsRefresh(action) {
  try {
    const payload = yield call(api.getViolations, action.jobId)
    yield put({ type: constants.VIOLATIONS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.VIOLATIONS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchViolations() {
  yield takeLatest(constants.VIOLATIONS_REFRESH.ACTION, violationsRefresh)
}

function* getViolationAttachments(action) {
  try {
    const payload = yield call(api.getViolationAttachments, action.violationId)
    yield put({ type: constants.GET_VIOLATION_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_VIOLATION_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetViolationAttachments() {
  yield takeLatest(constants.GET_VIOLATION_ATTACHMENTS.ACTION, getViolationAttachments)
}

function* uploadViolationAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      violationId: action.violationId
    }

    yield call(api.uploadViolationAttachments, payload)
    yield put({ type: constants.UPLOAD_VIOLATION_ATTACHMENT.SUCCESS, payload })
    yield call(getViolationAttachments, { violationId: action.violationId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_VIOLATION_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadViolationAttachments() {
  yield takeLatest(constants.UPLOAD_VIOLATION_ATTACHMENT.ACTION, uploadViolationAttachments)
}

function* deleteViolationAttachments(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      violationId: action.violationId
    }

    yield call(api.deleteViolationAttachment, payload)
    yield put({ type: constants.DELETE_VIOLATION_ATTACHMENT.SUCCESS, payload })
    yield call(getViolationAttachments, { violationId: action.violationId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_VIOLATION_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteViolationAttachments() {
  yield takeLatest(constants.DELETE_VIOLATION_ATTACHMENT.ACTION, deleteViolationAttachments)
}

function* sagaCreateViolation(action) {
  try {
    const payload = {
      formData: action.formData,
      jobId: action.jobId
    }
    yield call(api.createViolation, payload)
    yield put({ type: constants.VIOLATION_CREATE.SUCCESS, payload })
    yield call(violationsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.VIOLATION_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateViolation() {
  yield takeLatest(constants.VIOLATION_CREATE.ACTION, sagaCreateViolation)
}

function* sagaUpdateViolation(action) {
  try {
    const payload = {
      job_id: action.jobId,
      violation_id: action.violationId,
      content: action.content,
      updated_by_id: action.userId,
      user_id: 1
    }
    yield call(api.updateViolation, payload)
    yield put({ type: constants.VIOLATION_UPDATE.SUCCESS, payload })
    yield call(violationsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.VIOLATION_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateViolation() {
  yield takeLatest(constants.VIOLATION_UPDATE.ACTION, sagaUpdateViolation)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getViolationAttachments, { violationId: action.violationId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(constants.UPDATE_ATTACHMENT_DESCRIPTION.ACTION, updateAttachmentDescription)
}

function* sagaDeleteViolation(action) {
  try {
    const payload = {
      violation_id: action.violationId
    }
    yield call(api.deleteViolation, payload)
    yield put({ type: constants.VIOLATION_DELETE.SUCCESS, payload })
    yield call(violationsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.VIOLATION_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteViolation() {
  yield takeLatest(constants.VIOLATION_DELETE.ACTION, sagaDeleteViolation)
}

function* editViolationStatus(action) {
  try {
    const payload = {
      content: action.content,
      violationId: action.violationId,
      job_id: action.jobId
    }
    yield call(api.editViolationStatus, payload)
    yield put({ type: constants.EDIT_VIOLATION_STATUS.SUCCESS, payload })
    yield call(violationsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_VIOLATION_STATUS.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditViolationStatus() {
  yield takeLatest(constants.EDIT_VIOLATION_STATUS.ACTION, editViolationStatus)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchViolations),
    fork(watchGetViolationAttachments),
    fork(watchUploadViolationAttachments),
    fork(watchDeleteViolationAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchCreateViolation),
    fork(watchUpdateViolation),
    fork(watchDeleteViolation),
    fork(watchEditViolationStatus)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/violationSaga.js